import { useState } from "react";
import { motion } from "framer-motion";
import { PROCESS } from "@/lib/data";

export const Process = () => {
  const [active, setActive] = useState(0);
  return (
    <section id="process" className="py-24 lg:py-40 bg-paper border-t border-border">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
          <div>
            <span className="mono text-[10px] uppercase tracking-[0.25em] text-clay">Section · 04 — Process</span>
            <h2 className="font-display text-4xl lg:text-6xl text-ink mt-4 leading-[1.02] tracking-[-0.03em]">
              From feasibility to <em className="font-light">adopted plan.</em>
            </h2>
          </div>
          <p className="text-base lg:text-lg text-foreground/70 max-w-md">
            Five disciplined phases. Built around how agencies actually move — not how decks pretend they do.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* Steps list */}
          <div className="lg:col-span-5">
            <ol className="space-y-1">
              {PROCESS.map((p, i) => {
                const isActive = i === active;
                return (
                  <li key={p.step}>
                    <button
                      onClick={() => setActive(i)}
                      className={`w-full text-left py-5 border-t border-border flex items-baseline gap-6 transition-colors ${
                        isActive ? 'text-ink' : 'text-foreground/55 hover:text-ink'
                      }`}
                    >
                      <span className={`mono text-[11px] tracking-[0.22em] ${isActive ? 'text-clay' : ''}`}>{p.step}</span>
                      <span className="font-display text-2xl lg:text-3xl flex-1">{p.title}</span>
                      <span className={`block h-px transition-all ${isActive ? 'w-12 bg-clay' : 'w-6 bg-border'}`} />
                    </button>
                  </li>
                );
              })}
              <li className="border-t border-border" />
            </ol>
          </div>

          {/* Detail panel */}
          <div className="lg:col-span-7">
            <div className="sticky top-28 bg-secondary border border-border p-8 lg:p-12 min-h-[480px] flex flex-col grain">
              <motion.div
                key={PROCESS[active].step}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                <div className="flex items-center justify-between">
                  <span className="mono text-[10px] uppercase tracking-[0.25em] text-clay">Phase {PROCESS[active].step}</span>
                  <span className="mono text-[10px] text-muted-foreground">{active + 1} / {PROCESS.length}</span>
                </div>
                <h3 className="font-display text-4xl lg:text-6xl text-ink mt-6 leading-[1.02] tracking-[-0.02em]">
                  {PROCESS[active].title}
                </h3>
                <p className="mt-6 text-base lg:text-lg text-foreground/80 max-w-xl leading-relaxed">
                  {PROCESS[active].body}
                </p>
              </motion.div>

              <div className="mt-auto pt-10 grid grid-cols-1 sm:grid-cols-3 gap-6 border-t border-border">
                <div>
                  <div className="mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Typical duration</div>
                  <div className="font-display text-xl sm:text-2xl text-ink mt-1">{['4–8 weeks', '4–9 months', '3–6 months', '3–9 months', 'Ongoing'][active]}</div>
                </div>
                <div>
                  <div className="mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Deliverable</div>
                  <div className="font-display text-xl sm:text-2xl text-ink mt-1">{['Feasibility memo', 'Draft plan', 'Submittal pkg', 'Adopted plan', 'Program PMO'][active]}</div>
                </div>
                <div>
                  <div className="mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Stakeholder</div>
                  <div className="font-display text-xl sm:text-2xl text-ink mt-1">{['Owner', 'Planning', 'Multi-dept', 'Council', 'Consortium'][active]}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
